DialogController = App.loadClass 'core::Angular/DialogController'

class exports.ManageController extends DialogController

    constructor: (@scope, @transitions, @modalInstance, @service) ->
        super
        @scope.resize = 0
        @accept = []
        @deny = []


    save: () =>
        requests = _.filter @scope.requests, (request) =>
            return typeof request.accepted isnt 'undefined'

        @service.saveAdvisorRequest(requests).then (response) =>
            jsr = response.data
            @closeWithAlert(jsr.status)
